import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import { formatNumber } from "../../../utils/common-function";
import Box from "@material-ui/core/Box";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DescriptionIcon from "@material-ui/icons/Description";
import Tooltip from "@material-ui/core/Tooltip";

const tooltipFormatter = (cell, row) => (
  <Tooltip title={`${cell}`} arrow>
    <span>
      {cell?.substr(0, 50)}
      {cell?.length > 50 ? "..." : ""}
    </span>
  </Tooltip>
);

export const getUserDataManagementColumns = (
  downloadTemplateMaster,
  viewHistory
) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <CloudUploadIcon
              color="action"
              onClick={() => {
                downloadTemplateMaster(row);
              }}
            />
            <DescriptionIcon
              color="action"
              onClick={() => {
                viewHistory(row.TEMPLATE_ID);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "HOST_TITLE",
      text: "Host Title",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { minWidth: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "TEMPLATE_ID",
      text: "Template ID",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: (cell, row, rowIndex) => {
        return <>{formatNumber(row.TEMPLATE_ID, 5)}</>;
      },
    },
    {
      dataField: "TEMPLATE_NAME",
      text: "Template Name",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "CREATE_DATE",
      text: "Last Upload Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.CREATE_DATE)}</>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "EFFECTIVE_DATE",
      text: "Effective Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.EFFECTIVE_DATE)}</>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "CREATE_BY",
      text: "Upload By",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "STATUS_NAME",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "MESSAGE",
      text: "Message",
      sort: true,
      formatter: tooltipFormatter,
      headerAlign: "center",
    },
  ];
  return columns;
};
export const getUserDataManagementHistoryColumns = (
  downloadUserData,
  viewHistory
) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        const isMessageEmpty = !row.MESSAGE;
        return (
          <Box component="div" display="flex" justifyContent="center">
            <CloudDownloadIcon
              color="action"
              onClick={() => {
                downloadUserData(row);
              }}
            />
            <DescriptionIcon
              color={isMessageEmpty ? "disabled" : "action"}
              onClick={() => {
                if (!isMessageEmpty) viewHistory(row);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "HISTORY_ID",
      text: "History ID",
      sort: true,
    },
    {
      dataField: "HOST_TITLE",
      text: "Host Title",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { minWidth: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "PATH_FILE_OLD",
      text: "File Name",
      sort: true,
    },
    {
      dataField: "TEMPLATE_VERSION",
      text: "Template Version",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "EFFECTIVE_DATE",
      text: "Effective Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateFullMonthText(row.EFFECTIVE_DATE)}</>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "CREATE_DATE",
      text: "Last Upload Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { minWidth: "150px", textAlign: "center" };
      },
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.CREATE_DATE)}</>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "CREATE_BY",
      text: "Upload By",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "VERSION",
      text: "Version",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "STATUS_NAME",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "MESSAGE",
      text: "Message",
      sort: true,
      formatter: tooltipFormatter,
      headerAlign: "center",
    },
  ];
  return columns;
};

export const getUserDataDownloadTemplateColumns = (downloadTemplate) => {
  const columns = [
    {
      dataField: "TEMPLATE_NAME",
      text: "Template Name",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "VERSION",
      text: "Template Version",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "OP2",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <CloudDownloadIcon
              color="action"
              onClick={() => {
                downloadTemplate(row.TEMPLATE_ID);
              }}
            />
          </Box>
        );
      },
    },
  ];
  return columns;
};
